import create from 'zustand'

import { StatusTypes, StatusErrorTypes } from 'types/status'
import { OrdersWestfieldCorpDataTypes } from 'types/orders-westfieldcorp'

interface OrdersStoreTypes {
  // UPDATE
  ordersUpdateModErrors: StatusErrorTypes
  ordersUpdateModErrorsSet: (ordersModErrors: StatusErrorTypes) => void
  ordersUpdateModStatus: StatusTypes
  ordersUpdateModStatusSet: (ordersUpdateStatus: StatusTypes) => void

  ordersModErrors: StatusErrorTypes
  ordersModErrorsSet: (ordersModErrors: StatusErrorTypes) => void
  ordersModStatus: StatusTypes
  ordersModStatusSet: (ordersStatus: StatusTypes) => void
  orders: OrdersWestfieldCorpDataTypes[]
  ordersSet: (orders: OrdersWestfieldCorpDataTypes[]) => void
  ordersLookup: OrdersWestfieldCorpDataTypes[]
  ordersLookupSet: (orders: OrdersWestfieldCorpDataTypes[]) => void
}

export const useOrdersStore = create<OrdersStoreTypes>((set) => ({
  // UPDATE
  ordersUpdateModErrors: '',
  ordersUpdateModErrorsSet: (ordersUpdateModErrors) => {
    set({
      ordersUpdateModErrors,
    })
  },
  ordersUpdateModStatus: 'idle',
  ordersUpdateModStatusSet: (ordersUpdateModStatus) => {
    set({
      ordersUpdateModStatus,
    })
  },
  // DEFAULT
  ordersModErrors: '',
  ordersModErrorsSet: (ordersModErrors) => {
    set({
      ordersModErrors,
    })
  },
  ordersModStatus: 'idle',
  ordersModStatusSet: (ordersModStatus) => {
    set({
      ordersModStatus,
    })
  },
  orders: [],
  ordersSet: (orders) => {
    set({
      orders,
    })
  },
  ordersLookup: [],
  ordersLookupSet: (ordersLookup) => {
    set({
      ordersLookup,
    })
  },
}))

interface OrdersLookupStoreTypes {
  ordersLookupModErrors: StatusErrorTypes
  ordersLookupModErrorsSet: (ordersLookupModErrors: StatusErrorTypes) => void
  ordersLookupModStatus: StatusTypes
  ordersLookupModStatusSet: (ordersLookupStatus: StatusTypes) => void
  ordersLookup: OrdersWestfieldCorpDataTypes[]
  ordersLookupSet: (ordersLookup: OrdersWestfieldCorpDataTypes[]) => void
}

export const useOrdersLookupStore = create<OrdersLookupStoreTypes>((set) => ({
  ordersLookupModErrors: '',
  ordersLookupModErrorsSet: (ordersLookupModErrors) => {
    set({
      ordersLookupModErrors,
    })
  },
  ordersLookupModStatus: 'idle',
  ordersLookupModStatusSet: (ordersLookupModStatus) => {
    set({
      ordersLookupModStatus,
    })
  },
  ordersLookup: [],
  ordersLookupSet: (ordersLookup) => {
    set({
      ordersLookup,
    })
  },
}))
